import {
  Page as PageComponent,
  PageBody,
  PageContent,
  PageContentHeader,
  PageHeader,
  PageHeaderSection
} from "./Page";

export const Page = Object.assign(PageComponent, {
  Body: PageBody,
  Header: PageHeader,
  HeaderSection: PageHeaderSection,
  Content: PageContent,
  ContentHeader: PageContentHeader
});
